import { render, staticRenderFns } from "./shop-payment.vue?vue&type=template&id=514d9eea"
import script from "./shop-payment.vue?vue&type=script&lang=js"
export * from "./shop-payment.vue?vue&type=script&lang=js"
import style0 from "./shop-payment.vue?vue&type=style&index=0&id=514d9eea&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports